const PUBLIC_PRODUCT_FILTER_CONFIG = function(opt) {
	return [{
		label: '商品类型',
		type: 'radio',
		code: 'is_point',
		options: [{
			name: '普通商品',
			value: 0
		}, {
			name: '积分商品',
			value: 1
		}],
		handle(val, backfill) {
			if (!backfill) {
				this.set({
					activity: '',
					product_ids: []
				}, true);
			}
			this.unitStore.commit('hidden', Object.assign({}, this.hiddenUnit, {
				activity: val == 1
			}));
			this.unitStore.commit('pointsProdut', Object.assign({}, this.produtUnitType, {
				product_ids: val == 1
			}));
		}
	}, {
		label: '推荐方式',
		type: 'group',
		groupStyle: false,
		code: 'select_type',
		options: [{
			name: '按条件',
			value: 1,
			content: [{
				label: '所属品牌',
				type: 'select',
				code: 'brand',
				options: 'BRAND'
			}, {
				label: '所属类目',
				type: 'select',
				code: 'classify_ids',
				options: 'PRODUCT_CLASSIFY',
				multiple: true
			}, {
				label: '参与活动',
				type: 'select',
				code: 'activity',
				options: 'ACTIVITY'
			}, {
				label: '排序规则',
				type: 'select',
				code: 'sort_type',
				options: [{
					name: '按综合排序',
					value: 'overall desc'
				}, {
					name: '按首次上架时间降序',
					value: 'first_sell_date desc'
				}, {
					name: '按销量降序',
					value: 'product_count desc'
				}]
			}]
		}, {
			name: '手动推荐',
			value: 2,
			content: [{
				label: '手动选择',
				type: 'product',
				code: 'product_ids'
			}]
		}]
	}];
};

const link_area = [{
	tab: '内容设置',
	tips: '添加图片后，可在图片上自由划动添加热区',
	content: [{
		type: 'link_area',
		code: 'data'
	}]
}]

export {PUBLIC_PRODUCT_FILTER_CONFIG, link_area};